import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setStorage } from 'utilz';

import Button from './commponents/Button';
import InputMail from './commponents/inputMail';
import InputPass from './commponents/inputPass';
import Logo from './commponents/Logo';
import LogoForgotPass from './commponents/LogoForgotPass';

import containerActions from './actions';

import './styles.scss';


class Admin extends Component {
  constructor () {
    super();
    this.state = {
      mailStatus: false,
      mailForgotPassStatus: false,
      fogotPass: false
    };
  }
  componentWillMount() {
    setStorage({
      loginadmin: {
        mail: '',
        mailForgot: '',
        pass: ''
      }
    });
  }
getMailStatus = (status) => {
  if (status !== this.state.mailStatus) {
    this.setState({
      mailStatus: status
    });
  }
};

getMailForgotPassStatus = (status) => {
  if (status !== this.state.mailForgotPassStatus) {
    this.setState({
      mailForgotPassStatus: status
    });
  }
};

typePass = (e) => {
  this.props.passChange(e.target.value);
}
typeMail = (e) => {
  this.props.mailChange(e.target.value);
}
typeMailForgot = (e) => {
  this.props.mailChangeForgotPass(e.target.value);
}
singIN = () => {
  this.props.adminLogin({
    loginAdmin: this.props.mail,
    passAdmin: this.props.pass
  });
}
showForgotPassPage = () => {
  this.setState({
    fogotPass: !this.state.fogotPass
  });
}
changePassSendReq = () => {
  this.props.changePassReq(this.props.mailForgot);
}
render() {
  return (
    <div className="pageAdmin-body">
      {this.state.fogotPass ?
        <div className="pageAdmin-mainField">
          <LogoForgotPass />
          <InputMail
            cheked={this.state.mailForgotPassStatus}
            Value={this.props.mailForgot}
            mailIsOk={this.getMailForgotPassStatus}
            onChange={this.typeMailForgot}
          />
          <Button
            Caption="Send me reset link"
            buttonStyle="adminButton"
            Disabled={!this.state.mailForgotPassStatus}
            onHandleClick={this.changePassSendReq}
          />
          <Button Caption="Back to sign in" buttonStyle="adminLink" onHandleClick={this.showForgotPassPage} />
        </div>
      :
        <div className="pageAdmin-mainField">
          <Logo />
          <InputMail
            cheked={this.state.mailStatus}
            Value={this.props.mail}
            mailIsOk={this.getMailStatus}
            onChange={this.typeMail}
          />
          <InputPass onChange={this.typePass} />
          <Button
            Caption="Sign In"
            buttonStyle="adminButton"
            Disabled={this.props.pass.length === 0 ||
            !this.state.mailStatus}
            onHandleClick={this.singIN}
          />
          <Button Caption="Forgot a password?" buttonStyle="adminLink" onHandleClick={this.showForgotPassPage} />
        </div>
        }
    </div>
  );
}
}
Admin.propTypes = {
  passChange: PropTypes.func.isRequired,
  mailChange: PropTypes.func.isRequired,
  mailChangeForgotPass: PropTypes.func.isRequired,
  changePassReq: PropTypes.func.isRequired,
  adminLogin: PropTypes.func.isRequired,
  mail: PropTypes.string.isRequired,
  mailForgot: PropTypes.string.isRequired,
  pass: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  mail: state.loginadmin.mail,
  mailForgot: state.loginadmin.mailForgot,
  pass: state.loginadmin.pass
});

export default connect(mapStateToProps, containerActions)(Admin);



// WEBPACK FOOTER //
// ./src/pages/LoginAdmin/index.js